import { useParams } from 'react-router-dom';

export const useDuplicatesId = () => {
    const params = useParams();

    return {
        initialItemId: params['*'],
    };
};
